/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import ITiposMovimientos from './entidades/tiposMovimientos';

export default class ModeloTiposMovimientos {
    public consultarTiposMovimientos() {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocioConfiguracion.get('TiposMovimientos/ConsultarListaTiposMovimientos')
        );
    }

    public consultarTiposDocumentosCompuestoFiltro() {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocioConfiguracion.get('TiposMovimientos/ConsultarTiposDocumentosCompuestoFiltro')
        );
    }

    public crearTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocioConfiguracion.post('TiposMovimientos/GuardarTiposMovimientos', tiposMovimientos)
        );
    }

    public editarTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocioConfiguracion.put('TiposMovimientos/EditarTiposMovimientos', tiposMovimientos)
        );
    }

    public eliminarTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        return manejadorRest<IRespuesta<ITiposMovimientos>>(() =>
            negocioConfiguracion.delete('TiposMovimientos/EliminarTiposMovimientos', tiposMovimientos)
        );
    }
}
